import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="451.256"
      height="852"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 451.256 852"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1986.244 -244.5)"
      >
        <path strokeWidth="5" d="M2432 247l-442 38" opacity="1"></path>
        <path strokeWidth="3" d="M2433 287l-435 32" opacity="1"></path>
        <path strokeWidth="3" d="M2000 349l433-29" opacity="1"></path>
        <path strokeWidth="5" d="M2432 343l-431 25" opacity="1"></path>
        <path strokeWidth="3" d="M2018 370l29 8 16 15" opacity="1"></path>
        <path strokeWidth="3" d="M2048 378l384-21" opacity="1"></path>
        <path strokeWidth="3" d="M2432 373l-369 20-1 246" opacity="1"></path>
        <path strokeWidth="3" d="M2046 379v260" opacity="1"></path>
        <path strokeWidth="5" d="M2016 370v670l419 34" opacity="1"></path>
        <path
          strokeWidth="3"
          d="M2435 1025l-398-21 1-363 395 2"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M2433 660l-379-1-1 310 382 14"
          opacity="1"
        ></path>
        <path strokeWidth="5" d="M2001 369l-1 689 435 36" opacity="1"></path>
        <path strokeWidth="5" d="M2016 1041l-13 14" opacity="1"></path>
        <path
          strokeWidth="5"
          d="M1989 285c0 3.294-.54 6.783 0 10 .36 2.142 2.45 3.817 3 6 .45 1.814.55 5.194 1 7 .73 2.914 2.4 4.013 3 7 .47 2.332 0 3.5 0 7s.19 4.33 0 7c-.16 2.257-1.66 4.28-2 6-.42 2.096 2.59 4.737 4 7 1.74 2.783 1 6 1 6 0 4-2.28 5.415-3 9-.79 3.926 2.3 5.6 4 9"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;